var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrivacyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.40492 0.298715C3.20727 0.104874 2.94255 -0.00238432 2.66778 4.02271e-05C2.393 0.00246477 2.13015 0.114379 1.93585 0.311678C1.74155 0.508977 1.63133 0.775875 1.62895 1.05489C1.62656 1.3339 1.73219 1.6027 1.92309 1.8034L16.5948 16.7013C16.7924 16.8951 17.0571 17.0024 17.3319 17C17.6067 16.9975 17.8695 16.8856 18.0638 16.6883C18.2581 16.491 18.3683 16.2241 18.3707 15.9451C18.3731 15.6661 18.2675 15.3973 18.0766 15.1966L16.5329 13.6291C18.1652 12.3076 19.3722 10.5218 19.9996 8.5C18.6645 4.18281 14.6927 1.05106 9.99984 1.05106C8.35706 1.0488 6.73697 1.44038 5.27137 2.19394L3.40492 0.298715ZM7.87035 4.83193L9.45699 6.44409C9.81235 6.34827 10.1863 6.3489 10.5413 6.44593C10.8963 6.54296 11.2201 6.73299 11.48 6.99698C11.74 7.26097 11.9272 7.58968 12.0227 7.95019C12.1183 8.31071 12.1189 8.69038 12.0245 9.05122L13.6112 10.6623C14.0838 9.84935 14.2768 8.8999 14.1599 7.96333C14.043 7.02677 13.6228 6.15624 12.9654 5.48869C12.308 4.82114 11.4507 4.39446 10.5284 4.27576C9.60602 4.15706 8.67098 4.35202 7.87035 4.83193Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5715 15.6267L9.7378 12.7483C8.71883 12.6834 7.7582 12.2432 7.03617 11.5103C6.31415 10.7773 5.88038 9.80199 5.81627 8.76733L1.96705 4.85876C1.08173 5.9293 0.413269 7.16678 0 8.50023C1.33512 12.8174 5.308 15.9492 9.99979 15.9492C10.8874 15.9492 11.7489 15.8374 12.5715 15.6267Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacyIcon);
export default __webpack_public_path__ + "static/media/PrivacyIcon.5662485d8e286523fd092f0b9f3b6680.svg";
export { ForwardRef as ReactComponent };